module.exports = __webpack_public_path__ + "img/navigation_2763373.8eb1535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/navigation_2763373.png
// module id = 1853
// module chunks = 1